export const USER_CONFIG_TYPES = {
    VARIANT: 'VARIANT',
}